// Radar mark from the walk mocks: concentric rings + sweep dot, "Field" white / "Radar" teal.
export function RadarMark({ size = 28, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" className={className} aria-hidden="true">
      <circle cx="20" cy="20" r="17" fill="none" stroke="#14b8a6" strokeWidth="3"/>
      <circle cx="20" cy="20" r="10" fill="none" stroke="#14b8a6" strokeWidth="3" opacity=".75"/>
      <circle cx="20" cy="20" r="3.5" fill="#14b8a6"/>
      <path d="M20 20 L32 9" stroke="#14b8a6" strokeWidth="3" strokeLinecap="round"/>
    </svg>
  );
}

export default function FieldRadarLogo({ size = 28, dark = true, sub, className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="fr-logo">
      <RadarMark size={size}/>
      <div className="leading-none">
        <div className={`font-black tracking-tight ${dark ? "text-white" : "text-[#0b1c2d]"}`} style={{ fontSize: size * 0.78 }}>
          Field <span className="text-teal-400">Radar</span>
        </div>
        {sub && <div className="text-[10px] font-black uppercase tracking-[0.2em] text-teal-400 mt-1">{sub}</div>}
      </div>
    </div>
  );
}
